import styled from "styled-components";

const StyledClient = styled.div`
    display: flex;
    justify-content: center;
`

export default StyledClient;